var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgUsFlagIcon = function SvgUsFlagIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#us-flag-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 15,
    rx: 3,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0h9v7H0V0Z",
    fill: "#1A47B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 0v1h12V0H9Zm0 2v1h12V2H9Zm0 2v1h12V4H9Zm0 2v1h12V6H9ZM0 8v1h21V8H0Zm0 2v1h21v-1H0Zm0 2v1h21v-1H0Zm0 2v1h21v-1H0Z",
    fill: "#F93939"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 1v1h1V1H1Zm2 0v1h1V1H3Zm2 0v1h1V1H5Zm2 0v1h1V1H7ZM6 2v1h1V2H6ZM4 2v1h1V2H4ZM2 2v1h1V2H2ZM1 3v1h1V3H1Zm2 0v1h1V3H3Zm2 0v1h1V3H5Zm2 0v1h1V3H7ZM1 5v1h1V5H1Zm2 0v1h1V5H3Zm2 0v1h1V5H5Zm2 0v1h1V5H7ZM6 4v1h1V4H6ZM4 4v1h1V4H4ZM2 4v1h1V4H2Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "us-flag-icon_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 15,
    rx: 3,
    fill: "#fff"
  })))));
};

export default SvgUsFlagIcon;